




















































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Messages, { Message, Rule } from "../core/messages";
import Snack from "../utils/snack";
import RuleBuilder from "./RuleBuilder.vue";

@Component({
  components: {
    RuleBuilder,
  },
})
export default class NewMessage extends Vue {
  // Props
  @Prop({ required: true, type: Boolean })
  show!: boolean;

  @Prop({ required: true, type: String })
  currentUserId!: string;

  // Data
  userId = "";
  token = "";
  type: "hero" | "inbox" = "inbox";
  template = {
    title: "",
    body: "",
    ctaText: undefined,
    ctaUrl: undefined,
  };
  rawTemplates = "";
  rawUserData = "";
  rawExpiresAt: null | string = null;
  tags: string[] = [];
  clearMessagesWithTags: string[] = [];
  rules: Rule | null = null;

  isFormValid = false;
  showDatePicker = false;

  validationRules = {
    staticToken: [(v: string) => !!v || "Token is required"],
    userId: [(v: string) => !!v || "User id is required"],
    template: {
      title: [(v: string) => !!v || "Template title is required"],
      body: [(v: string) => !!v || "Template body is required"],
      ctaUrl: [
        (v: string) => {
          let url;
          try {
            url = new URL(v);
          } catch (_) {
            return "Invalid URL";
          }
          return (
            url.protocol === "http:" ||
            url.protocol === "https:" ||
            "Invalid URL"
          );
        },
      ],
    },
    userData: [
      (v: string) => {
        if (!v) {
          return true;
        }
        try {
          JSON.parse(v);
          return true;
        } catch (err) {
          return "Invalid JSON";
        }
      },
      (v: string) => {
        if (!v) {
          return true;
        }
        try {
          const parsed = JSON.parse(v);
          return this.isPlainObject(parsed) || "User data must be an object";
        } catch (err) {
          return "Invalid JSON";
        }
      },
    ],
  };

  // Computed
  get isVisible() {
    return this.show;
  }
  set isVisible(visible: boolean) {
    if (visible) {
      return;
    }
    this.$emit("close");
  }

  get message(): Message {
    const msg: Message = {
      userId: this.userId,
      type: this.type,
      template: this.template,
      tags: this.tags.length > 0 ? this.tags : undefined,
      clearMessagesWithTags:
        this.clearMessagesWithTags.length > 0
          ? this.clearMessagesWithTags
          : undefined,
    };

    if (this.rawUserData) {
      msg.userData = JSON.parse(this.rawUserData);
    }
    if (this.rawExpiresAt) {
      msg.expiresAt = new Date(this.rawExpiresAt).toISOString();
    }
    if (this.rules) {
      msg.rules = this.rules;
    }

    return msg;
  }

  // Methods
  isPlainObject(obj: any) {
    return (
      obj !== null && Object.prototype.toString.call(obj) === "[object Object]"
    );
  }

  async send() {
    const token = this.token;
    try {
      await Messages.sendMessage(this.message, token);
      Snack.success("Message sent successfully.");
      this.isVisible = false;
    } catch (err) {
      Snack.error(`Failed sending message with error: <br>${err}`);
    }
  }

  // Watchers
  @Watch("currentUserId")
  userIdChangeHandler() {
    this.userId = this.currentUserId;
  }

  // Life-cycle hooks
}
